var map = {
	"./brownie-stuffed-sourdough-chocolate-chip.json": 359,
	"./chocolate-chip-mm.json": 672,
	"./classic-chocolate-chip.json": 392,
	"./monster-cookies.json": 980,
	"./oatmeal-scotchies.json": 63,
	"./smores-sourdough-cookie.json": 405,
	"./triple-chocolate-chunk-sourdough.json": 542,
	"./unicorn-cookies.json": 422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 469;